import { useQueryClient } from '@tanstack/react-query';
import { dryRunSyncSchoolFromEdlink, getSchool, getSchools, syncSchoolFromEdlink } from '@/lib/api-calls.js';
import { SyncEdlinkModal } from '@/components/edlink/sync-edlink-modal.js';

type SyncEdlinkSchoolProps = {
  schoolId: string;
  schoolName: string;
  schoolEdlinkId: string;
  trigger: React.ReactNode;
};

export const SyncEdlinkSchool = ({ schoolId, schoolName, schoolEdlinkId, trigger }: SyncEdlinkSchoolProps) => {
  const queryClient = useQueryClient();

  return (
    <SyncEdlinkModal
      modalTitle="Sync Edlink school"
      entityName={schoolName}
      entityId={schoolEdlinkId}
      trigger={trigger}
      syncFn={() => syncSchoolFromEdlink(schoolId)}
      dryRunFn={() => dryRunSyncSchoolFromEdlink(schoolId)}
      onSyncSuccess={() => {
        queryClient.invalidateQueries(getSchools());
        queryClient.invalidateQueries(getSchool(schoolId));
      }}
      syncSentryTags={{ feature: 'edlink-sync-school', schoolId }}
      dryRunSentryTags={{ feature: 'edlink-sync-school-dry-run', schoolId }}
      syncErrorMessage="Edlink School sync failed. Please try again or contact support."
    />
  );
};
